import { Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Switch } from '@mui/material'
import React,{useState} from 'react'
import { useAppData } from '../../../../../context/AppDataContext'
import { CheckBox, CheckBoxOutlineBlank, CheckCircle } from '@mui/icons-material';
import calendarServices from '../calendarServices';
import { useAlert } from '../../../../../context/AlertContext';

function EventStatusUpdate({event}) {
    const {getMasterLabel,masters,getCalendarEventList} = useAppData();
    const {AppAlert} = useAlert()
    const [dialogStatus,setDialogStatus] = useState(false);
    const [currentStatus,setCurrentStatus] = useState(event.status);
    const [notify,setNotify] = useState(false);


    const [saving,setSavingStatus] = useState(false);

    const update = () =>{
        setSavingStatus(true)
        let payload = {
            id:event.id,
            status:currentStatus,
            notify:notify
        }
        calendarServices.save(payload).then(res=>{
            AppAlert("Satatus Updated");
            setDialogStatus(false);
            getCalendarEventList();
        }).catch(error=>{
            AppAlert("Something went Wrong! Try Again","error");
            console.log(error);
        }).finally(()=>setSavingStatus(false))

    }


    return (
        <>
            <Chip label={ getMasterLabel("task-status", event.status)} size="small" variant='outlined' onClick={()=>setDialogStatus(true)}  />
             <Dialog open={dialogStatus} onClose={() => setDialogStatus(false)} fullWidth maxWidth="sm" >
                <DialogTitle>Update Staus</DialogTitle>
                <DialogContent>
                    <div>
                        {masters["task-status"].map(taskStatus=>
                            <button 
                                className={currentStatus == taskStatus.value ? "btn btn-warning m-2" : "btn btn-outline-dark m-2"} 
                                onClick={()=>setCurrentStatus(taskStatus.value)}
                            >
                                {currentStatus === taskStatus.value ? <CheckBox/> : <CheckBoxOutlineBlank/> }
                                <sapn className="ms-2">{taskStatus.label} </sapn>
                            </button>
                        )}
                    </div>

                    <div>
                        <label className="form-label fw-bold">Notify via Email: </label>
                        <Switch label="Notify" checked={notify} onChange={()=>setNotify(!notify)} />
                    </div>
                </DialogContent>
                <DialogActions>
                    <button className='btn btn-outline-dark' onClick={()=>setDialogStatus(false)} > Canncel</button>
                    {!saving ?
                            <button className='btn btn-success' onClick={update} disabled={event.status == currentStatus}  > Update Status</button>
                        :
                            <CircularProgress/>
                    }
                </DialogActions>

             </Dialog>
        </>
    )
}

export default EventStatusUpdate